import { useState, useEffect } from 'react';
import { getAuthToken } from '../utils/auth';

/* Statut connecté (token local), réévalué au focus et entre onglets */
export const useAuthStatus = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(() => !!getAuthToken());

  useEffect(() => {
    const refresh = () => setIsLoggedIn(!!getAuthToken());
    refresh();
    window.addEventListener('focus', refresh);
    window.addEventListener('storage', refresh);
    return () => {
      window.removeEventListener('focus', refresh);
      window.removeEventListener('storage', refresh);
    };
  }, []);

  return isLoggedIn;
};

export default useAuthStatus;
